import { Box, Card, CircularProgress, Grid, Typography, Fade } from '@mui/material'
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import LockIcon from '@mui/icons-material/Lock';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const formatMinutes = (min) => {
    if (!min || min === 0) return '0 min';
    const hrs = Math.floor(min / 60);
    const mins = Math.round(min % 60);
    if (hrs === 0) return `${mins} min`;
    return `${hrs}h ${mins}m`;
};

const DashboardCards = ({ dashboard, isLoadingDash, isDarkMode }) => {
    const cards = [
        {
            label: 'Total Tickets',
            value: dashboard?.totalTickets ?? '-',
            icon: <ConfirmationNumberIcon sx={{ fontSize: 28, color: '#fff' }} />,
            gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            shadow: 'rgba(102,126,234,0.4)',
        },
        {
            label: 'Abiertos',
            value: dashboard?.totalAbiertos ?? '-',
            icon: <LockOpenIcon sx={{ fontSize: 28, color: '#fff' }} />,
            gradient: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
            shadow: 'rgba(67,233,123,0.4)',
        },
        {
            label: 'Cerrados',
            value: dashboard?.totalCerrados ?? '-',
            icon: <LockIcon sx={{ fontSize: 28, color: '#fff' }} />,
            gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
            shadow: 'rgba(79,172,254,0.4)',
        },
        {
            label: 'Vencidos',
            value: dashboard?.totalVencidos ?? '-',
            icon: <WarningAmberIcon sx={{ fontSize: 28, color: '#fff' }} />,
            gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            shadow: 'rgba(245,87,108,0.4)',
        },
        {
            label: 'Prom. Resolución',
            value: dashboard?.promedioResolucionMin != null ? formatMinutes(dashboard.promedioResolucionMin) : '-',
            icon: <AccessTimeIcon sx={{ fontSize: 28, color: '#fff' }} />,
            gradient: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)',
            shadow: 'rgba(252,182,159,0.4)',
        },
    ];

    return (
        <Grid container spacing={2}>
            {cards.map((card, idx) => (
                <Grid item xs={12} sm={6} md={4} lg key={card.label}>
                    <Fade in={true} timeout={400 + idx * 150}>
                        <Card sx={{
                            position: 'relative',
                            background: isDarkMode
                                ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)'
                                : 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                            borderRadius: '16px',
                            boxShadow: isDarkMode
                                ? '0 4px 20px rgba(0,0,0,0.3)'
                                : '0 4px 20px rgba(0,0,0,0.06)',
                            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0',
                            p: 2.5,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                            willChange: 'transform',
                            '&:hover': {
                                transform: 'translateY(-2px)',
                                boxShadow: isDarkMode
                                    ? '0 6px 24px rgba(0,0,0,0.4)'
                                    : `0 6px 24px ${card.shadow}`,
                            }
                        }}>
                            <Box sx={{
                                width: 52,
                                height: 52,
                                borderRadius: '14px',
                                background: card.gradient,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: `0 4px 14px ${card.shadow}`,
                                flexShrink: 0,
                            }}>
                                {card.icon}
                            </Box>
                            <Box>
                                <Typography sx={{
                                    color: isDarkMode ? '#b0bec5' : '#7f8c8d',
                                    fontSize: 12,
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    {card.label}
                                </Typography>
                                <Typography sx={{
                                    color: isDarkMode ? '#e0e0e0' : '#2c3e50',
                                    fontSize: 26,
                                    fontWeight: 700,
                                    lineHeight: 1.2,
                                }}>
                                    {isLoadingDash ? <CircularProgress size={20} sx={{ color: '#0364ff' }} /> : card.value}
                                </Typography>
                            </Box>
                        </Card>
                    </Fade>
                </Grid>
            ))}
        </Grid>
    );
};

export default DashboardCards;
